import { Component, OnInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { AuthUtils } from 'src/app/shared/util/auth.utils';
import { DateUtils } from 'src/app/shared/util/date-utils';
import { SessionService } from 'src/app/core/service/session.service';
import { AuthService } from 'src/app/core/auth/service/auth.service';
import { UserData } from 'src/app/core/service/model/userData.model';
import { UserDataService } from 'src/app/core/service/user-data.service';
import { DialogService } from 'src/app/core/service/dialog.service';
import { SessionTimerComponent } from 'src/app/shared/components/session-timer/session-timer.component';
import { Globals } from 'src/app/shared/helpers/globals';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [RouterLink, NgIf, MatButtonModule, MatMenuModule, SessionTimerComponent]
})
export class HeaderComponent implements OnInit {

  userData: UserData = {} as UserData;

  sessionTime!: number;

  constructor(
    private sessionService: SessionService,
    public dialogService: DialogService,
    private _authService: AuthService,
    private _userService: UserDataService,
    private globals: Globals,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loadSessionTime();
    this.sessionService.sessionTimeUpdated$.subscribe(() => {
      this.loadSessionTime();
    })

    this._userService.userData.subscribe(userData =>{
      this.userData = userData;
    });
  }

  timeOver(event){
    const token = this._authService.accessToken;
    if(token)
      this.openSessaoExpiradaDialog();
  }

  public openSessaoExpiradaDialog(): void {
    this.dialogService.showConfirmation(
        ['Sua sessão expirou!', 'Fazer o login novamente?'], 'Sim', 'Não', '400px'
      ).subscribe(result => {
        if(result){
          this._authService.removeToken();
          this.router.navigate(['/login']);
        } else {
          this.logout();
        }
      });
  }

  private loadSessionTime() {
    const token = this._authService.accessToken;
    if (token) {
      const currentTime = new Date();
      const tokenExpiresIn = (AuthUtils._getTokenExpirationDate(token) || new Date());
      this.sessionTime = Math.floor(DateUtils.diffInMinutes(currentTime, tokenExpiresIn));
    }
  }

  public isUserLoggedIn(){
    return this._authService.isAuthenticated;
  }

  public logout(): void {
    this.globals.addToLoading("ordem");
    this._authService.logout(false);
  }

}
